"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const lodash_1 = require("lodash");
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const constants_1 = __importStar(require("@/constants"));
const __1 = require("..");
const FormError = ({ className, formError, metaValidation }) => {
    if (!formError)
        return null;
    let errorMessage = constants_1.default.general.thereWasAnError;
    if (formError.details && typeof formError.details === 'string') {
        errorMessage = formError.details;
    }
    else if (formError.error && lodash_1.isObject(formError.error)) {
        [errorMessage,] = lodash_1.find(formError.error, 'non_field_error') || [errorMessage];
    }
    else if (formError.error && lodash_1.isString(formError.error)) {
        errorMessage = formError.error;
    }
    if (metaValidation && !metaValidation(formError.meta))
        return null;
    return React.createElement(__1.Banner, { className: className, icon: constants_1.Images.bannerWarningIcon, borderRadius: "5px", backgroundColor: "rgba(218, 20, 20, 0.1)", description: errorMessage });
};
FormError.defaultProps = {
    className: '',
    metaValidation: undefined,
    formError: undefined
};
const mapStateToProps = (state, props) => ({
    formError: radio_dispatch_1.selectors.getError(state, props.formKey),
});
exports.default = react_redux_1.connect(mapStateToProps)(FormError);
